export const SUB_STEP_POST_CARD = 'SUB_STEP_POST_CARD';
export const UPDATE_POSTCARD_SUBSTEP = 'UPDATE_POSTCARD_SUBSTEP';

export const SELECT_BACKGROUND_POST_CARD = 'SELECT_BACKGROUND_POST_CARD';

export const FETCH_ADDRESS = 'FETCH_ADDRESS';
export const FETCH_ADDRESS_SUCCESS = 'FETCH_ADDRESS_SUCCESS';
export const FETCH_ADDRESS_FAILURE = 'FETCH_ADDRESS_FAILURE';

export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';


export const LOGIN_USER = 'LOGIN_USER';
export const LOGGED_IN_USER = 'LOGGED_IN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';

export const UPLOAD_PHOTO = 'UPLOAD_PHOTO';
export const UPLOAD_PHOTO_SUCCESS = 'UPLOAD_PHOTO_SUCCESS';
export const UPLOAD_PHOTO_FAILURE = 'UPLOAD_PHOTO_FAILURE';

export const REMOVE_IMAGE = 'REMOVE_IMAGE';

export const NAVIGATE_BACK = 'NAVIGATE_BACK';

export const RESET_ROAR_FLOW = 'RESET_ROAR_FLOW';



export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';



// WEBPACK FOOTER //
// ./src/common/constants/index.js